module.exports = __webpack_public_path__ + "media/recipes/117-2100d2bd.png";